import React, { ReactNode, useMemo } from 'react';
import styled from 'styled-components/macro';
import useClinicUser from 'shared/hooks/useClinicUser';

interface IMentionedUser {
  children?: ReactNode;
}

const MentionedUser = ({ children }: IMentionedUser): JSX.Element => {
  const { clinicUser } = useClinicUser();

  const isCurrentUser = useMemo((): boolean => {
    if (!clinicUser || !children) return false;
    const { nameDisplay, firstName, lastName } = clinicUser;
    const mentionedUser = children.toString();
    const currentUser = nameDisplay ? `@${nameDisplay}` : `@${firstName} ${lastName}`;

    return mentionedUser === currentUser;
  }, [clinicUser, children]);

  return <Container isCurrentUser={isCurrentUser}>{children}</Container>;
};

const Container = styled.span<{ isCurrentUser: boolean }>`
  font-weight: 400;
  color: var(--chakra-colors-text-subtle);
  background-color: ${({ isCurrentUser }): string =>
    isCurrentUser ? `var(--chakra-colors-background-warning)` : `var(--chakra-colors-background-primaryAlpha)`}};
  padding: 0 5px;
  border-radius: 4px;
  display: inline-block;
`;

export default MentionedUser;
